import { useTranslation, useI18next } from 'gatsby-plugin-react-i18next'
import React from 'react'

import logo from '../../2021/images/logo.svg'
import flagCs from '../../2021/images/flag-cs.svg'
import flagEn from '../../2021/images/flag-en.svg'

import * as styles from './styles.module.scss'
import AnimatedText from '../AnimatedText'

const flags = {
	cs: flagCs,
	en: flagEn
}

const Header: React.FC = () => {
	const { t } = useTranslation()
	const { languages, changeLanguage, language: currentLanguage } = useI18next()

	return (
		<header className={styles.header}>
			<div className="container text-center">
				<nav className="pt-4 pt-md-7">
					<div className="text-end">
						<ul className="d-inline-flex list-unstyled">
							{languages.map((lng) => (
								<li key={lng}>
									<a
										href="#"
										className={`mx-2 ${
											currentLanguage !== lng ? styles.opacity50 : ''
										}`}
										onClick={(e) => {
											e.preventDefault()
											changeLanguage(lng)
										}}
									>
										<img src={flags[lng as 'cs' | 'en']} alt={lng} />
									</a>
								</li>
							))}
						</ul>
					</div>
				</nav>
				<img src={logo} alt="NOTINO" className={styles.logo} />
				<h1 className="display-1 mt-5">
					<strong>
						<AnimatedText text={'2021'} delay={1} />
					</strong>{' '}
					{/* <span className="display-2">
						<AnimatedText
							text={t('headline.notino')}
							delay={t('headline.year').length / 10 + 0.6}
						/>
					</span> */}
				</h1>
			</div>
		</header>
	)
}

export default Header
